module.exports = __webpack_public_path__ + "media/images/icons/filled/bug-5366034f200653aa9e70a385bacb0838.svg";